/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedules_Last_RunInputs */



/**
* | output |
* | --- |
* | "Last run" |
*
* @param {Agent_Schedules_Last_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedules_last_run = /** @type {((inputs?: Agent_Schedules_Last_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedules_Last_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzter Lauf")
	return /** @type {LocalizedString} */ ("Last run")
});